export const downloadBlob = (blob: Blob, fileName = 'file', fileExtension = 'txt') => {
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.style.display = 'none';
  link.href = blobUrl;
  link.download = `${fileName}.${fileExtension}`;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};
